import { jsx } from 'react/jsx-runtime';
import { useState, useRef } from 'react';
import { styled, css } from 'styled-components';
import { useResourceVideoDataContextSafe } from '../../../context/resourceDataContext.js';
import { useMediaPlayerControls } from '../useMediaPlayerControls.js';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useQueryResourceTranscript } from '../../../../queries/useQueryResourceTranscript.js';
import { useDomContentRect } from '@fabric-app/hooks/useDomContentRect';
import { ResourceMediaPlayer } from '../MediaPlayer/ResourceMediaPlayer.js';
import { useRouteTParamChange } from '../../hooks/useRouteTParamChange.js';

const ResourceVideoPlayer = () => {
  const { resource } = useResourceVideoDataContextSafe();
  const { transcriptLines } = useQueryResourceTranscript(resource);
  const [videoState, setVideoState] = useState({
    aspectRatio: resource.data?.attributes?.dimensions?.width && resource.data?.attributes?.dimensions?.height ? resource.data.attributes.dimensions.width / resource.data.attributes.dimensions.height : 16 / 9,
    isAudioOnly: false,
    isReady: false
  });
  const containerRef = useRef(null);
  const [containerRect] = useDomContentRect(containerRef.current);
  const { mediaElementProps, mediaElementRef, mediaTimestamp } = useMediaPlayerControls(resource.id);
  const onVideoLoaded = (e) => {
    const videoWidth = e.currentTarget?.videoWidth || 0;
    const videoHeight = e.currentTarget?.videoHeight || 0;
    setVideoState((s) => ({
      ...s,
      isReady: true,
      ...videoWidth === 0 ? {
        aspectRatio: videoWidth / videoHeight
      } : void 0,
      isAudioOnly: videoWidth === 0
    }));
  };
  const startPlayAt = async (time) => {
    if (!mediaElementRef.current) return;
    await mediaElementRef.current.play();
    mediaElementRef.current.currentTime = time;
  };
  const onClickTranscript = (cue) => {
    startPlayAt(cue.startTime);
  };
  const videoMaxHeight = containerRect?.height ? containerRect.height - 40 : void 0;
  const videoMaxWidth = videoMaxHeight ? videoMaxHeight * videoState.aspectRatio : void 0;
  useRouteTParamChange({
    onParamChange: startPlayAt,
    enabled: videoState.isReady
  });
  return /* @__PURE__ */ jsx(ResourceMediaPlayer, {
    transcriptLines: transcriptLines ?? void 0,
    currentTimestamp: mediaTimestamp ?? void 0,
    onTranscriptClick: onClickTranscript,
    containerRef,
    "data-pan-id-ignore-resource-drag-resize": "xy",
    children: resource.fileUrl && /* @__PURE__ */ jsx(Video, {
      poster: resource.thumbnail?.md,
      src: resource.fileUrl,
      controls: true,
      draggable: false,
      ...mediaElementProps,
      preload: "metadata",
      onLoadedMetadata: onVideoLoaded,
      ref: mediaElementRef,
      style: {
        maxHeight: videoMaxHeight,
        maxWidth: videoMaxWidth
      },
      isAudioOnly: videoState.isAudioOnly
    })
  });
};
const Video = styled.video.withConfig({
  displayName: "ResourceVideoPlayer__Video",
  componentId: "sc-baa066c7-0"
})([
  `height:100%;width:100%;border-radius:6px;background:`,
  `;`,
  ``
], cssVar["color-bg-primary"], ({ isAudioOnly }) => isAudioOnly && css([
  `width:100%;height:54px;border-radius:0;background:transparent;`
]));

export { ResourceVideoPlayer };
//# sourceMappingURL=ResourceVideoPlayer.js.map
